<div *ngFor="let item of items">
  <app-onboarding-checklist-item [item]="item" (close)="handleClose()"></app-onboarding-checklist-item>
</div>
